// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1sjax","content":"ManualTimeModal_content__PZEeB"};